module.exports = __webpack_public_path__ + "media/assets/icons/ic-more-horizontal-1289119548f11d92cd03e0eb9d8c8f75.svg";